/**
 * Variant Product Switcher JavaScript
 * Handles interactive filtering for size and color combinations
 */

let selectedSize = null;
let selectedColor = null;
let variantData = null;

function initializeVariantSwitcher() {
  const dataScript = document.querySelector('[id^="variant-data-"]');
  if (dataScript) {
    try {
      variantData = JSON.parse(dataScript.textContent);
      if (!variantData || typeof variantData !== 'object') {
        throw new Error('Invalid variant data structure');
      }
      if (!Array.isArray(variantData.combinations)) {
        variantData.combinations = [];
      }
      selectedSize = variantData.currentSize;
      selectedColor = variantData.currentColor;
      
      updateButtonStates();
      updateAvailableOptions();
    } catch (error) {
      console.error('Error parsing variant data:', error);
      variantData = { combinations: [], hasSizeOptions: false, hasColorOptions: false };
    }
  }
}

function filterVariantsBySize(size) {
  selectedSize = size;
  updateButtonStates();
  updateAvailableOptions();
  
  if (variantData.hasSizeOptions && variantData.hasColorOptions) {
    if (selectedSize && selectedColor) {
      redirectToVariant(selectedSize, selectedColor, 'size');
    }
  } else if (variantData.hasSizeOptions && !variantData.hasColorOptions) {
    redirectToVariant(selectedSize, null);
  }
}

function filterVariantsByColor(color) {
  selectedColor = color;
  updateButtonStates();
  updateAvailableOptions();
  
  if (variantData.hasSizeOptions && variantData.hasColorOptions) {
    if (selectedSize && selectedColor) {
      redirectToVariant(selectedSize, selectedColor, 'color');
    }
  } else if (variantData.hasColorOptions && !variantData.hasSizeOptions) {
    redirectToVariant(null, selectedColor);
  }
}

function updateButtonStates() {
  const sizeButtons = document.querySelectorAll('.vps-wrapper--size .vps-item--size');
  sizeButtons.forEach(button => {
    button.classList.remove('current');
    if (button.dataset.size === selectedSize) {
      button.classList.add('current');
    }
  });
  
  const colorButtons = document.querySelectorAll('.vps-wrapper--color .vps-item--color');
  colorButtons.forEach(button => {
    button.classList.remove('current');
    if (button.dataset.color === selectedColor) {
      button.classList.add('current');
    }
  });
  
  const sizeValueSpan = document.querySelector('.variant-section--size .current-value');
  const colorValueSpan = document.querySelector('.variant-section--color .current-value');
  
  if (sizeValueSpan && selectedSize) {
    sizeValueSpan.textContent = selectedSize;
  }
  
  if (colorValueSpan && selectedColor) {
    colorValueSpan.textContent = selectedColor;
  }
}

function updateAvailableOptions() {
  if (!variantData || !variantData.combinations) return;
  
  if (!variantData.hasSizeOptions || !variantData.hasColorOptions) {
    return;
  }
  
  const availableColorsForSize = selectedSize ? 
    variantData.combinations
      .filter(combo => combo.size === selectedSize)
      .map(combo => combo.color) : [];
  
  const availableSizesForColor = selectedColor ? 
    variantData.combinations
      .filter(combo => combo.color === selectedColor)
      .map(combo => combo.size) : [];

  // Hodnota mimo aktuální kombinaci zůstává klikatelná, jen je označená. Klik na ni
  // vede na sourozence s jinou hodnotou druhé osy, stejně jako ve sticky liště.
  const setButtonAvailability = (button, isAvailable) => {
    if (isAvailable) {
      button.classList.remove('is-unpaired');
    } else {
      button.classList.add('is-unpaired');
    }
  };
  
  const colorButtons = document.querySelectorAll('.vps-wrapper--color .vps-item--color');
  colorButtons.forEach(button => {
    const color = button.dataset.color;
    if (selectedSize) {
      setButtonAvailability(button, availableColorsForSize.includes(color));
    } else {
      setButtonAvailability(button, true);
    }
  });
  
  const sizeButtons = document.querySelectorAll('.vps-wrapper--size .vps-item--size');
  sizeButtons.forEach(button => {
    const size = button.dataset.size;
    if (selectedColor) {
      setButtonAvailability(button, availableSizesForColor.includes(size));
    } else {
      setButtonAvailability(button, true);
    }
  });
}


function redirectToVariant(size, color, clickedAxis) {
  if (!variantData || !variantData.combinations) return;

  let matchingVariant = null;

  if (variantData.hasSizeOptions && variantData.hasColorOptions) {
    matchingVariant = variantData.combinations.find(combo =>
      combo.size === size && combo.color === color
    );
    // Kombinace neexistuje (20 cm se v krémové nevyrábí): zachovat kliknutou
    // hodnotu a vzít prvního sourozence, který ji má.
    if (!matchingVariant && clickedAxis) {
      matchingVariant = variantData.combinations.find(combo =>
        clickedAxis === 'size' ? combo.size === size : combo.color === color
      );
    }
  } else if (variantData.hasSizeOptions && !variantData.hasColorOptions) {
    matchingVariant = variantData.combinations.find(combo => 
      combo.size === size
    );
  } else if (variantData.hasColorOptions && !variantData.hasSizeOptions) {
    matchingVariant = variantData.combinations.find(combo => 
      combo.color === color
    );
  }
  
  if (matchingVariant && matchingVariant.url) {
    window.location.href = matchingVariant.url;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initializeVariantSwitcher();
});

window.filterVariantsBySize = filterVariantsBySize;
window.filterVariantsByColor = filterVariantsByColor; 